<template>
  <div id="app">
    <safari-view v-if="isSafari"></safari-view>
    <div v-else>
      <router-view></router-view>
      <confirmation-modal/>
    </div>
  </div>
</template>

<script>
  import SafariView from '@/components/common/safari-view/safari-view';
  import ConfirmationModal from './components/common/confirmation.modal/confirmation.modal';

  export default {
    name: 'app',
    data() {
      return {
        isSafari: false
      };
    },
    components: {
      ConfirmationModal,
      SafariView
    },
    mounted() {
      this.$store.dispatch('getCurrentUser');
      this.$store.dispatch('checkBroadcastingStatus');
    },
    created() {
      this.isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    }
  };
</script>

<style lang="scss">
  @import 'style.scss';
  @import './stylesheets/global.scss';
</style>



// WEBPACK FOOTER //
// app.vue?409142a0